import {Provider} from '@angular/core';
import {ClientHttpProvider} from '@shared/infrastructure/http/client.http.provider';
import {LocalStorageAdapterProvider} from '@shared/infrastructure/storage/local/local.storage.adapter.provider';

import {
  MyHistoryCreditHttpAdapter
} from '@features/credit/infrastructure/http/my-history-credit/my-history-credit.http.adapter';
import {NavigationAdapterProvider} from '@shared/infrastructure/navigation/navigation.adapter.provider';
import {
  MyHistoryCreditUseCasePort
} from '@features/credit/application/use_cases/my-history-credit/my-history-credit.use-case.port';

export const MyHistoryCreditHttpProvider: Provider[] = [
  ClientHttpProvider,
  LocalStorageAdapterProvider,
  NavigationAdapterProvider,
  {
    provide: MyHistoryCreditUseCasePort,
    useClass: MyHistoryCreditHttpAdapter
  }
];
